import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { KwikspaceModule } from '../app/components/pwa/pwa.module';

import { LoggedInGuardService } from './services/logged-in-guard.service';
import { LoginComponent } from './components/auth/login/login.component';

import { AppRoutes } from 'src/app/shared/endpoints.enum';

const routes: Routes = [
  {
    path: AppRoutes.LOGIN,
    component: LoginComponent,
    canActivate: [LoggedInGuardService],
  },
  {
    path: AppRoutes.PWA,
    loadChildren: () =>
      import('../app/components/pwa/pwa.module').then(
        (m) => m.KwikspaceModule
      ),
  },
  { path: '', redirectTo: `${AppRoutes.PWA}quotes`, pathMatch: 'full' },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    KwikspaceModule.forRoot()
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
